import Lookup from 'src/componentes/select2';

const TipoIdentificacaoFormularioGlobalLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoIdentificacaoFormularioGlobalLookup"
    clearable={false}
    {...rest}
  />
);

export default TipoIdentificacaoFormularioGlobalLookup;